import {action} from 'typesafe-actions';
import {BillingActionTypes, BillingDocument} from './types';

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export const getBillingDocumentRequest = (billingDocumentId: string) =>
  action(BillingActionTypes.GET_BILLING_DOCUMENT_REQUEST, billingDocumentId);
export const getBillingDocumentSuccess = (billingDocument: BillingDocument) =>
    action(BillingActionTypes.GET_BILLING_DOCUMENT_SUCCESS, billingDocument);
